import React from 'react'
import { useHelpOverlay } from '@fs/zion-help-overlay'
import { NoticeQuestion, MenuSearch, HelpTip, HelpCompass, ActivityLearn, SocialChat } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { MenuOverlay, ListItem } from '@fs/zion-ui'
import { useFeatureFlag } from '@fs/zion-flags'
import { baseUrl } from '@fs/zion-config'
import HeaderIconButton from '../../../shared/components/HeaderIconButton'
import { useNavigationContext } from '../shared/NavigationProvider/NavigationProvider'

const HELP_ICON_MAP = {
  'search-articles': MenuSearch,
  'help-and-learning': HelpTip,
  'getting-started': HelpCompass,
  'help-resources': ActivityLearn,
  'contact-us': SocialChat,
}

function HelpSubmenuDropdown({ linkName, external }) {
  const { t } = useTranslation()
  const { helpNavigation } = useNavigationContext()
  const helpAndLearning = helpNavigation?.find((item) => item.id === 'help-and-learning')
  const label = helpAndLearning?.text || 'Help and Learning'

  return (
    <MenuOverlay
      menuButton={
        <HeaderIconButton title={label} linkName={linkName} data-selector="helpOverlayButton" Icon={NoticeQuestion} />
      }
      aria-label={t('header.help.submenu', 'Submenu')}
    >
      {helpNavigation?.map((item) => {
        const Icon = HELP_ICON_MAP[item.id] || NoticeQuestion
        const url = `${external && item.url.startsWith('/') ? baseUrl : ''}${item.url}`
        return (
          <ListItem
            key={item.id}
            dense
            primaryText={item.text}
            startElement={<ListItem.Icon Icon={Icon} />}
            to={url}
            external
            linkName={item.linkName}
          />
        )
      })}
    </MenuOverlay>
  )
}

function HeaderHelpButtonLegacy({ linkName }) {
  const { handleClick } = useHelpOverlay(window?.location?.href)
  const { t } = useTranslation()
  return (
    <HeaderIconButton
      title={t('nav.help', 'Help')}
      linkName={linkName}
      data-selector="helpOverlayButton"
      Icon={NoticeQuestion}
      onClick={handleClick}
    />
  )
}

export default function HeaderHelpButton({ linkName, external }) {
  const { isOn: helpLinksDropdownOn } = useFeatureFlag('home_header_helpLinksDropdown')

  if (helpLinksDropdownOn) {
    return <HelpSubmenuDropdown linkName={linkName} external={external} />
  }

  return <HeaderHelpButtonLegacy linkName={linkName} />
}
